<template>
  <div id="main">
    <div class="infoimg" v-show="showinfo">
        <img class="img" src="../assets/info.png">
        <div class="infotip">{{info}}</div>
    </div>
    <ul v-show="showinfo==false">
        <ul v-for="item in list" :key="item.id">
            <div class="infomaina">
                <div class="mainimg" :style="{'background-image':'url(' + item.img +')'}">
                    <!-- <img :src="item.img"> -->
                </div>
                <div class="detailinfo">
                    <div class="info1">
                        <div class="topinfo1">
                            <div class="titlex">
                                {{item.name}}                    
                            </div>
                            <div class="price">
                                ￥{{item.price}}                    
                            </div>
                        </div>                        
                        <div class="buttonx">
                            <mt-button type="primary" @click="Selectseats(item.id)" size="small" >购票</mt-button>
                        </div>                        
                    </div>
                    <div class="info2">
                        <div class="bottoninfo1">
                            <h1 class="scoreinfo">{{item.score}}</h1>
                        </div>
                        <div class="bottoninfo2">
                            <div class="leadinfo">
                                主演:{{item.leadrole}}
                            </div>
                            <div class="datex">
                                放映时间:{{item.playdate}} {{item.playtime}}
                            </div>
                        </div>
                        
                    </div>                    
                </div>                
            </div>
        </ul>
    </ul> 

    <div class="tabbar" v-show!="showinfo">
        <mt-tabbar v-model="selected" fixed='fixed'>
            <mt-tab-item id="ticketlist">
                <img slot="icon" src="../assets/home.png">
                首页
            </mt-tab-item>
            <mt-tab-item id="ownlist">
                <img slot="icon" src="../assets/user.png">
                我的
            </mt-tab-item>
        </mt-tabbar>
    </div>
  </div>  
</template>

<script>
import Axios from 'axios'
import qs from 'qs';
import { MessageBox } from 'mint-ui';

export default {
  name: 'main',
  data () {
    return {
      msg: '这里是在线购票',  
      selected: 'ticketlist',
      showinfo:false,
      info:'',
      openid:'',   
      wxbaseinfo:{
        name:'',
        departmnet:'',
        serial:'',
        prenum:'',
        visittime:''
      },
      idnumber:'',
      username:'',
      list:[]
    }
  },
  watch: {
    selected: function(newV, oldV) {
      // mt-tab-item id
    //   console.log('newV',newV);
        //   console.log(this.selected);
      // this.$router.push({name: newV});
      // 编程导航 参数对应routes里面的命名name
      this.$router.push({name: this.selected});
    }
  },
  created(){      
    // 1、从缓存读取身份证号、姓名
    var temopenid = localStorage.getItem('idnumber');
    var temname = localStorage.getItem('username');
    if(temopenid!='undefined' && temname!='undefined'){
        // 缓存存在
        this.idnumber=temopenid;
        this.username=temname;
    }
    // 2、加载票务列表
    this.loadticketlist();    
  },
  methods:{
    // 验证用户信息
    checkInfo(){
      // 验证个人信息
      var api='http://localhost:6334/api/checkinfo';
      Axios.post(api,qs.stringify({
        'openid':this.openid
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
        }).then(response=>{
              if(response.data.result=='false'){
                  // 出错了，则跳到出错处理页面
                  this.$router.push({path:'/err'});
              }
              else{
                if(response.data.data.name==null || response.data.data.name==''){
                    // 没有姓名信息跳转到完善基本信息
                    // this.$router.push({path:'/baseinfo'})
                    this.$router.push({name:'baseinfo',params:{'openid':response.data.data.openid}});
                }
                else{                    
                  // 信息完事，则正常显示 
                  this.idnumber=response.data.data.idnumber;
                  this.loadappointmentlist();
              }
            }
      }),function(err){
          alert('appointment验证用户失败：' + err);
      }
    },  
    // 获取票务列表
    loadticketlist(){
        var api='http://shzjapi.romis.cn:59848/api/getticketlist';
        Axios.get(api).then((response)=>{            
            if(response.data.result=='false'){
                // 无记录
                // this.$router.push({path:'/err'});
                this.info=response.data.errmsg;
                this.showinfo=true;
            }
            else{
                // 解码用 
                this.showinfo=false;
                this.list=response.data.data                
            }
        }).catch((err)=>{
            alert('ticketlist获取票务列表失败：' + err);
        })
    },
    // 选座
    Selectseats(value){
        // 1、如果已有身份证号了，验证此证是否已购买过此票了,若已购买则提示
        if(this.idnumber!=null && this.username!=null){
            var api='http://shzjapi.romis.cn:59848/api/checkidpurchased?ticketid=' + this.ticketid + '&idnumber=' + this.idnumber;
            Axios.get(api).then((response)=>{            
                if(response.data.result=='false'){
                    // 无记录
                    // this.$router.push({path:'/err'});
                    this.info=response.data.errmsg;
                    alert(this.info);
                        return;
                }
                else{
                    // 解码用 
                    console.log('ticketname',response.data.purchased);
                    if(response.data.purchased=='true')    {
                        // 已购买过此票了
                        alert('您已购买过此场票');
                        return;
                    }             
                }
            }).catch((err)=>{
                alert('验证购票信息失败：' + err);
                return;
            })
            
        }

        // 2、跳转到选座页面
        // this.$router.push({path:'/selectseat'});
        this.$router.push({name:'selectseat',params:{'ticketid':value}});
    }
  }
}
</script>

<style>

#main,/*设置占满*/
html,
body {
  background-color: #dbdbdb;
  width: 100%;
  height: 100%;
  margin: 0;
}
#main{
    height: auto;
}
.infomaina{
  width: 85%;
  height:110px;
  background-color:white;
  font-family: Arial; 
  border: 1px solid #f4f4f4; 
  border-radius: 6px; 
  padding: 10px 10px; 
  /* margin: 5%; */

  border: 1px solid #bfbfbf;
  box-shadow: 0px 3px 5px 2px #aaa;
  filter: opacity(60); 

  display: flex;
  flex-direction: row/column;
  flex-wrap: nowrap/wrap;
}
.mainimg{
    background-color: black;
    width:40%;
    height: 130px;
    /* background-repeat: no-repeat; */
    /* background-position: center; */
    background-size: cover;

    border-radius: 6px 0px 0px 6px; 

    margin: -10px auto -10px -10px ;
}
.detailinfo{
    background-color: white;
    width:60%;
    height: 100%;
    margin: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap/wrap;
}
.info1{
    width: auto;
    height: 50%;
    flex-direction: row;
    flex-wrap: nowrap/wrap;
    display: flex;
    /* background-color: red; */
}
.info2{
    width: auto;
    height: 50%;
    flex-direction: row;
    flex-wrap:initial;
}
.img{
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}
.buttonx{
    width: 40%;
    padding: 0px;
    margin-right: 0px;
    justify-content: center;
    align-items: center;
    /* background-color: blue; */
}
.topinfo1{
    font-size: 16px;
    width: 85%;
    font-weight: bold;
    display: flex;
    flex-direction: column;
}
.titlex{
  font-size: 14px;
  width: 85%;
  font-weight: bold;
  /* background-color: green; */
}
.price{
    font-size: 18px;
    font-weight: bold;
    color: red;
}
.info2{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    /* background-color: green; */
}
.bottoninfo1{
    width: 30%;
    height: 100%;
    display: flex; /* 设置为flex容器 */
   justify-content: center; /* 水平居中 */
   align-items: center; /* 垂直居中 */
    /* background-color: blue; */
}
.scoreinfo{
    font-size: 26px;
    color: rgb(134, 19, 241);
}
.leadinfo{
    height: 50%;
    width: 100%;
    font-size: 10px;
    display: flex; /* 设置为flex容器 */
   /* justify-content: center; 水平居中 */
   align-items: center; /* 垂直居中 */
    /* background-color: greenyellow; */
}
.datex{
    height: 50%;
    width: 100%;
    font-size: 10px;
    color: darkgray;
    /* background-color: red; */
}
.red{ 
  font-size: 20px;
  float:right; 
  width:80px; 
  color:red;
}
.orange{ 
  font-size: 20px;
  float:right; 
  width:80px; 
  color:orange;
}
.lightgrey{ 
  font-size: 20px;
  float:right; 
  width:80px; 
  color:lightgray;
}
.infodetail{
    top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/Ticketlist.vue